/* AFIQ redesign: gift card product (sections/afiq-giftcard-*.liquid). Port of site/gift-card.html.
   - Amount picker = the product's variants; it sets the product form's variant id (Dawn <product-form> adds to cart,
     carrying Shopify's native recipient fields), updates the live card and "what it covers" (AFIQ_UI.priceDecks).
   - Popular gifts grid: full system first, then Flag 5v5 and Basics. */
(function () {
  'use strict';
  if (window.__afiqGiftInit || !window.AFIQ_UI || !window.AFIQ) return;
  window.__afiqGiftInit = true;
  var U = window.AFIQ_UI, P = U.P, $ = U.$, esc = U.esc;

  var trust = document.querySelector('[data-afiq-trust]');
  if (trust) trust.outerHTML = U.trust();

  /* ---------- amount picker + live card ---------- */
  var root = document.querySelector('[data-afiq-giftcard]');
  if (root) {
    var el = function (k) { return root.querySelector('[data-el="' + k + '"]'); };
    var sid = root.getAttribute('data-section-id'), toDefault = root.getAttribute('data-to-default') || '';
    var btns = [].slice.call(el('amts').querySelectorAll('[data-variant]'));
    var elite = U.VOLS.length === 4 ? U.priceDecks(U.VOLS).total : 0;

    var covers = function (c, lbl) {
      var rows = [];
      if (P.basics && c >= P.basics.price) rows.push([['basics'], '<b>Football Basics</b> (' + $(P.basics.price) + ') for a brand-new player']);
      if (P.v1 && c >= P.v1.price) rows.push([['v1'], '<b>Any single deck</b> (' + $(P.v1.price) + '), like ' + esc(P.v1.label + ': ' + P.v1.title)]);
      if (elite && c >= elite) rows.push([U.VOLS, '<b>The full system</b> (' + $(elite) + '), all four volumes']);
      if (P.v1) { var team = U.priceDecks(Array(10).fill('v1')).total; if (c >= team) rows.push([['v1', 'v1', 'v1'], '<b>10 decks at team price</b> (' + $(team) + ') for a whole roster']); }
      return '<span class="fld" style="margin:0"><label style="margin:0">' + esc(lbl) + ' covers</label></span>' +
        rows.slice(-3).map(function (r) { return '<div>' + U.stack(r[0]) + '<span>' + r[1] + '</span></div>'; }).join('');
    };
    var select = function (b, focus) {
      if (!b || b.disabled) return;
      btns.forEach(function (x) { var on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-checked', on); x.tabIndex = on ? 0 : -1; });
      var c = +b.dataset.cents, lbl = b.dataset.label, id = b.dataset.variant;
      el('variant').value = id;
      el('amt').textContent = lbl;
      el('covers').innerHTML = covers(c, lbl);
      el('add-label').textContent = 'Add ' + lbl + ' gift card';
      if (focus) b.focus();
      /* keep Dawn's recipient form in sync (it matches cart errors by variant id) */
      if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try { window.publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId: sid, variant: { id: +id } } }); } catch (e) {}
      }
      var u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState(null, '', u);
    };
    el('amts').addEventListener('click', function (e) { var b = e.target.closest('[data-variant]'); if (b) select(b); });
    el('amts').addEventListener('keydown', function (e) {
      var k = e.key, i = btns.indexOf(document.activeElement); if (i < 0) return;
      var step = k === 'ArrowRight' || k === 'ArrowDown' ? 1 : k === 'ArrowLeft' || k === 'ArrowUp' ? -1 : 0; if (!step) return;
      e.preventDefault();
      for (var j = 1; j <= btns.length; j++) { var n = btns[(i + step * j + btns.length * j) % btns.length]; if (!n.disabled) { select(n, true); break; } }
    });
    var cur = btns.filter(function (x) { return x.classList.contains('on'); })[0] || btns.filter(function (x) { return !x.disabled; })[0];
    if (cur) {
      el('covers').innerHTML = covers(+cur.dataset.cents, cur.dataset.label);
    }

    /* live card: "For <recipient name>" */
    var nameIn = document.getElementById('Recipient-name-' + sid);
    if (nameIn) {
      var upd = function () { el('to').textContent = nameIn.value ? 'For ' + nameIn.value : toDefault; };
      nameIn.addEventListener('input', upd);
      root.addEventListener('change', function (e) { if (e.target && e.target.type === 'checkbox') setTimeout(upd, 0); });
    }
  }

  /* ---------- popular gifts: full system first ---------- */
  var picks = document.querySelector('[data-afiq-gift-picks]');
  if (picks) {
    var setCard = function () {
      var q = U.priceDecks(U.VOLS);
      return '<a class="dk setk" href="' + esc(U.bundleUrl('elite')) + '"><span class="dk-b alt">Most popular</span>' +
        '<div class="dk-img">' + U.stack(U.VOLS) + '</div>' +
        '<div class="dk-t"><span class="dk-k">Set · ' + U.VOLS.length + ' decks</span><b>The full system</b>' +
        '<span class="dk-r">Volumes 1–4 · ' + U.VOLS.reduce(function (s, d) { return s + (P[d].cards || 54); }, 0) + ' cards</span>' +
        '<span class="dk-p">' + $(q.total) + (q.save > 0 ? '<s>' + $(q.full) + '</s><span class="dk-save">Save ' + $(q.save) + '</span>' : '') + '</span></div></a>';
    };
    var keys = (picks.getAttribute('data-afiq-gift-picks') || 'elite,fl5,basics,v1').split(',').map(function (s) { return s.trim(); });
    picks.innerHTML = keys.map(function (k) {
      if (k === 'elite') return U.VOLS.length === 4 ? setCard() : '';
      return P[k] ? U.deckCard(k) : '';
    }).join('');
  }
})();
